import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { SwiperOptions } from 'swiper';

import { DevelopmentInfo } from '@interfaces/app';

@Component({
  selector: 'mnf-project-info-nav',
  templateUrl: './project-info-nav.component.html',
  styleUrls: ['./project-info-nav.component.scss']
})
export class ProjectInfoNavComponent implements OnInit, AfterViewInit {
  @Input() dev: DevelopmentInfo;

  images: SafeUrl[];
  videos: SafeUrl[];

  defaultImage = 'assets/load-img.jpg';

  carouselConfig: SwiperOptions = {
    direction: 'vertical',
    slidesPerView: 1,
    mousewheel: true,
    parallax: true,
    pagination: {
      clickable: true,
    },
  }

  loaded = false;
  // isMobile = window.innerWidth < 992;
  isMobile = false;

  constructor(private domSanitizer: DomSanitizer) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.images = this.dev?.images?.map(img => this.domSanitizer.bypassSecurityTrustResourceUrl(img))
      if(this.images.length === 0) {
        this.images = this.dev?.gallery?.map(img => this.domSanitizer.bypassSecurityTrustResourceUrl(img));
      }
      this.videos = this.dev?.videos?.map(video => this.domSanitizer.bypassSecurityTrustResourceUrl(video));
      this.adjustCarousel();
    }, 250)

  }

  ngAfterViewInit(): void {
      setTimeout(() => this.loaded = true, 500);
  }

  /**
   * Adjust carousel config based on screen size
   */
  adjustCarousel(): void {
    this.isMobile = window.innerWidth < 992;
    this.carouselConfig.mousewheel = !this.isMobile;
    this.carouselConfig.allowTouchMove = !this.isMobile;
    this.carouselConfig.allowSlideNext = !this.isMobile;
    this.carouselConfig.allowSlidePrev = !this.isMobile;
    this.carouselConfig.parallax = !this.isMobile;
  }

}
